export const toastDivSelector = 'div[class^="go"]';
export const errorIconSelector = 'div.go2415422094';
export const successIconSelector = 'div.go2673002540';
